import { render, staticRenderFns } from "./FieldTextarea.vue?vue&type=template&id=627672a0&"
import script from "./FieldTextarea.vue?vue&type=script&lang=js&"
export * from "./FieldTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports